import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './res/font/TenorSans-Regular.ttf';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);